import React, { useEffect } from 'react';

import { Box } from '@rbilabs/universal-components';

import { useProductCalories } from 'pages/menu/components/product-wizard/use-product-calories';
import { useProductTotalPrice } from 'pages/menu/components/product-wizard/use-product-total-price';
import { EventName, emitEvent } from 'utils/event-hub';

import { useProductWizardContext } from '../../product-wizard';
import { useProductWizardFlow } from '../../product-wizard/use-product-wizard-flow';

import { OverSodiumLimitWarning } from './over-sodium-limit-warning';
import { ProductPriceCaloriesContainer, ProductPriceCaloriesText } from './styled';

interface ProductPriceCaloriesProps {
  small?: boolean;
  showPlusSign?: boolean;
}

export const ProductPriceCalories = ({ small, showPlusSign }: ProductPriceCaloriesProps) => {
  const { selectedProduct, slotsSelections, productQuantity } = useProductWizardContext();
  const { cartIdEditing, rewardBenefitId } = useProductWizardFlow();
  const { formattedTotalPrice } = useProductTotalPrice(
    selectedProduct,
    slotsSelections,
    productQuantity,
    cartIdEditing,
    rewardBenefitId
  );
  const calories = useProductCalories(selectedProduct);

  const accessibilityLabel = `${formattedTotalPrice} ${calories}`;

  useEffect(() => {
    if (!calories) {
      return;
    }
    // Emit event for when calories are loaded since menu performance tracking uses this
    emitEvent(EventName.MENU_ITEM_CALORIES_LOADED);
  }, [calories]);

  return (
    <Box focusable accessibilityLabel={accessibilityLabel}>
      <ProductPriceCaloriesContainer>
        <ProductPriceCaloriesText small={!!small}>
          {showPlusSign && <Box fontWeight={'bold'}>+</Box>}
          {formattedTotalPrice && <Box fontWeight={'bold'}>{formattedTotalPrice}</Box>}
          {formattedTotalPrice && calories && ' | '}
          {calories && <Box>{calories}</Box>}
        </ProductPriceCaloriesText>
        {!small && <OverSodiumLimitWarning />}
      </ProductPriceCaloriesContainer>
    </Box>
  );
};
